module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vcbOfK/tc-custom/9781638292012.jpg?1705540719177",
      "alt": "This image is the cover for the book Studies in Smoke"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Studies in Smoke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_c('em', [_c('strong', [_vm._v("Studies in Smoke")])]), _c('strong', [_c('em')]), _vm._v("is not fiction. The shared event is actual and the resonance real. So is this.")]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_vm._v("This poetry remains faithful to traditional form. It is true to life and to living simply while thinking too much.")]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_vm._v("It is true to the cycle of uneasy, never settled sentiments that prescribe no moral, no message, no mysticism. In plain language and the fitting phrase, this work is authentic to the voices of inanimate shadings, to the shifting shapes that drift into evanescent experience.")]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_vm._v("This work offers the painterly touches not yet digitalized in the mind’s eye.")]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticClass: "Standard",
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Liberation Serif\", serif",
      "text-align": "center"
    }
  }, [_vm._v("Buy the ticket. Take the ride.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charles Edward Fremuth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Charles Edward Fremuth received a B.A. from Princeton University, where he published in "), _c('em', [_vm._v("The Nassau Lit")]), _vm._v(", and an M.A. from the University of Michigan. He dedicated his teaching career to Detroit Country Day School, where he served as chair of the English department for twenty-five years. The International Baccalaureate Organization appointed him assistant assessor in the Theory of Knowledge and site evaluator of prospective schools (1997"), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("–")]), _vm._v("2003). He led workshops in the Theory of Knowledge for teachers and heads of schools in the United States and Canada, and was selected to present “Epistemology in King Lear” at the International Baccalaureate North American Regional Conference (San Francisco 2008). His teaching was recognized in several local articles and by various national awards (1993, 2006"), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("–")]), _vm._v("2008). In 2017 he retired to collect his writings.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0